import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { Button } from "components";
import React from "react";
import { IConsumptionCalculationResultProps } from "./interfaces";
import { useStyles } from "./result-modal.styles";

export const ConsumptionCalculationResult = ({
  result,
  isOpen,
  onReset,
  onClose,
}: IConsumptionCalculationResultProps) => {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        className: classes.paper,
      }}
    >
      <DialogTitle id="alert-dialog-title" className={classes.title}>
        Résultat
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <span className={classes.resultLegend}>Consommation : </span>
          {result.consumptionPer100Liters} L/100 km
        </DialogContentText>
        <DialogContentText id="alert-dialog-description">
          <span className={classes.resultLegend}>Prix du trajet : </span>
          {result.cost} €
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={onClose} type="button" isFullWidth>
          Fermer
        </Button>
        <Button onClick={onReset} type="button" variant="outlined" isFullWidth>
          Reset
        </Button>
      </DialogActions>
    </Dialog>
  );
};
